import s from './Footer.module.scss';
import Title from '../Title/Title';
import { CheckCheck, Github, Linkedin, Mail } from 'lucide-react';
import { useState } from 'react';
import { handleCopy } from '../../utils';

export default function Footer() {
  const [emailIconState, setEmailIconState] = useState(false);

  // link
  const handleEmailClick = (e: React.MouseEvent) => {
    e.preventDefault();
    handleCopy('iliebanik@gmail.com');
    setEmailIconState(true);
    setTimeout(() => {
      setEmailIconState(false);
    }, 2000);
  };

  return (
    <div className={s.root_wrapper}>
      <div className={s.root}>
        <Title text="Ready for new challenges" size="medium" className={s.title} />
        <p className={s.desc}>If you have an interesting project or job opening, I would be happy to discuss
          opportunities for cooperation.</p>


        <div className={s.links}>
          <a
            className={s.link}
            href="https://github.com/CHchisho"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open Chebanik Ilia's GitHub profile"
            title="GitHub: Chebanik Ilia"
          >
            <Github size={20} aria-hidden="true" focusable="false" />
          </a>
          <a
            className={s.link}
            href="https://www.linkedin.com/in/ilia-chebanik/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Open Chebanik Ilia's LinkedIn profile"
            title="LinkedIn: Chebanik Ilia"
          >
            <Linkedin size={20} aria-hidden="true" focusable="false" />
          </a>
          <div className={s.link} onClick={handleEmailClick}>
            {emailIconState ? <CheckCheck size={20} /> : <Mail size={20} />}
          </div>

        </div>

      </div>
      <p className={s.copyright}>© {new Date().getFullYear()} Chebanik Ilia - Portfolio</p>
    </div>
  );
}
